import React from 'react';
import { 
  Box, 
  Typography, 
  Tooltip, 
  Paper
} from '@mui/material';
import DateRangeIcon from '@mui/icons-material/DateRange';

const AssessmentView = ({ assessment, ratingInfo, formatDate }) => {
  const IconComponent = ratingInfo ? ratingInfo.icon : null;

  return (

      <Paper 
      variant='section'
      >
        {/* تفاصيل التقييم */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 1 }}>
          
          <Typography variant="body2" color="text.primary">
            <Typography component="span" fontWeight="bold" color="text.secondary">عنوان الدرس: </Typography>
            {assessment.lessonTitle}
          </Typography>
          
          <Typography variant="body2" color="text.primary">
            <Typography component="span" fontWeight="bold" color="text.secondary">المعيار: </Typography>
            {assessment.assessmentCriteria?.title || "غير محدد"}
          </Typography>

          {/* === عرض مستوى التقييم كأيقونة === */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography component="span" variant="body2" fontWeight="bold" color="text.secondary" sx={{ ml: 1 }}>
              التقييم الوصفي: 
            </Typography>
            {IconComponent ? (
              <Tooltip title={ratingInfo.label} placement="top" arrow>
                <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'help' }}>
                  <IconComponent size={15} color={ratingInfo.color} />
                </Box>
              </Tooltip>
            ) : (
              <Typography variant="body2" color="text.disabled">غير محدد</Typography>
            )}
          </Box>

          {/* === عرض الوصف شرطياً إذا كان مختلفاً عن المستوى === */}
          {assessment.result && String(assessment.result) !== String(assessment.level) && (
            <Box sx={{ mt: 0.5, p: 1.5, bgcolor: 'rgba(0,0,0,0.02)', borderRadius: '8px', border: '1px dashed #e0e0e0' }}>
              <Typography variant="body2" color="text.primary">
                <Typography component="span" fontWeight="bold" color="text.secondary">العبارة الوصفية: </Typography>
                {assessment.result}
              </Typography>
            </Box>
          )}


          {/* === عرض الوصف شرطياً إذا كان مختلفاً عن المستوى === */}
          {assessment.result && String(assessment.result) === String(assessment.level) && (
            <Box sx={{ mt: 0.5, p: 1.5, bgcolor: 'rgba(0,0,0,0.02)', borderRadius: '8px', border: '1px dashed #e0e0e0' }}>
              <Typography variant="body2" color="text.primary">
                <Typography component="span" fontWeight="bold" color="text.secondary">العبارة الوصفية: </Typography>
                لم يتم تحدسد عبارة وصفية بعد
              </Typography>
            </Box>
          )}
          
        </Box>

        {/* التاريخ أسفل الكارت */}
        <Box sx={{ mt: 'auto', pt: 2, display: 'flex', alignItems: 'center', gap: 1, color: 'text.disabled' }}>
          <DateRangeIcon fontSize="small" />
          <Typography variant="caption">
            {formatDate(assessment.date)}
          </Typography>
        </Box>

      </Paper>

  );
};

export default AssessmentView;